/* eslint-disable import/no-default-export */
import React from 'react';
import { useDispatch } from 'react-redux';
import { removeOverlay } from 'app/gamma/src/modules/state/ui/overlay';
import { PlanSelectionOverlayConnected as PlanSelection } from 'app/src/components/FreeTrial/PlanSelectionOverlay';

const PlanSelectionOverlay: React.FC<{ orgId: string }> = ({ orgId }) => {
  const dispatch = useDispatch();
  return (
    <PlanSelection
      orgId={orgId}
      onClose={() => {
        dispatch(removeOverlay());
      }}
    />
  );
};

export default PlanSelectionOverlay;
